import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import type { AuthContextValue } from "@/auth/AuthProvider";

/**
 * Permite `staticData: { title, subtitle }` tipado em cada rota. Os dois
 * alimentam o cabeçalho ÚNICO do painel (`_authed`), e vêm daqui — não de
 * estado — porque a rota casada já é conhecida no mesmo render da navegação:
 * o cabeçalho troca junto com a tela, sem um quadro sequer exibindo o título
 * da tela anterior.
 */
declare module "@tanstack/react-router" {
  interface StaticDataRouteOption {
    title?: string;
    subtitle?: string;
  }
}

export interface RouterContext {
  queryClient: QueryClient;
  auth: AuthContextValue;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  notFoundComponent: NotFound,
});

function RootLayout() {
  return <Outlet />;
}

function NotFound() {
  return (
    <div className="grid h-full place-items-center p-8 text-center">
      <div>
        <p className="text-sm font-medium text-primary">404</p>
        <h1 className="mt-2 text-2xl font-semibold">Página não encontrada</h1>
      </div>
    </div>
  );
}
